import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";

export default class PageSubnav {
	static init() {

		let subNav = document.querySelector('.page-subnav');
		if( !subNav ){
			return;
		}

		let items = subNav.querySelectorAll('.item');
		items.forEach( item => {
			item.addEventListener('click', () => {

				let current = subNav.querySelector('.item.current');
				current.classList.remove('current');
				item.classList.add('current');

				let anchor = item.dataset.anchor;
				const target = document.getElementById(anchor);
				const inner = document.querySelector('.case-content-inner');
				const style = window.getComputedStyle(inner);
				const marginTop = style.marginTop;
				GlobalVariables.lenis.scrollTo(target, {
					offset: -parseInt(marginTop),
					duration: 1,
					easing: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
				});
			});
		});

		let anchors = document.querySelectorAll('.block-anchor .anchor');
		anchors.forEach( (anchor, i) => {
			ScrollTrigger.create({
				trigger: anchor,
				start: "top center",
				endTrigger: anchors[i+1],
				end: "top center",
				onEnter: () => {
					let current = subNav.querySelector('.item.current');
					current.classList.remove('current');
					let id = anchor.id;
					subNav.querySelector(`.item[data-anchor="${id}"]`).classList.add('current');
				},
				onEnterBack: () => {
					let current = subNav.querySelector('.item.current');
					current.classList.remove('current');
					let id = anchor.id;
					subNav.querySelector(`.item[data-anchor="${id}"]`).classList.add('current');
				}
			});
		});

	}
}